module.exports = __webpack_public_path__ + "static/media/list-view.2f3c0a77.svg";